import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, ref } from "vue";
import { Uuid } from "@/code/Uuid";
import { DataLayerApi } from "@/services/Api";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressRadioInput',
  props: {
  type: {
    type: String,
    default: "text",
  },
  name: String,
  value: String,
  placeholder: String,
  modelValue: String,
  disabled: Boolean,
  label: {
    type: String,
    required: false,
  },
  rules: {
    type: Object as PropType<object | string>,
    required: false,
  },
  id: {
    type: String,
    required: true,
  },
},
  emits: ["update:modelValue", "blur", "focus"],
  setup(__props, { emit }) {



const randomlyGeneratedId = ref<string>(Uuid.newUuid());

const onInput = (event: Event) => {
  if ((event.target as HTMLInputElement).name === "paymentMethod") {
    const paymentMethodValue = (event.target as HTMLInputElement).value;
    DataLayerApi.updateAddPaymentInfoEvent(paymentMethodValue);
  }
  emit("update:modelValue", (event.target as HTMLInputElement).value);
};
const onFocus = (event: Event) => {
  emit("focus", (event.target as HTMLInputElement).value);
};
const onBlur = (event: Event) => {
  emit("blur", (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!

  return (_openBlock(), _createBlock(_component_v_field, {
    id: __props.id || randomlyGeneratedId.value,
    name: __props.name,
    type: "radio",
    validateOnBlur: true,
    validateOnChange: false,
    validateOnInput: false,
    validateOnModelUpdate: false,
    onBlur: onBlur,
    value: __props.value,
    onFocus: onFocus,
    onInput: onInput,
    label: __props.label,
    rules: __props.rules,
    disabled: __props.disabled,
    class: "radio-input"
  }, null, 8, ["id", "name", "value", "label", "rules", "disabled"]))
}
}

})